import Chart from 'react-apexcharts';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { IconButton } from '@fluentui/react/lib/Button';
import { mergeStyles } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { userAPI } from '../UserAPI';
import { useAtom } from 'jotai';
import { authenticationAtom } from '../State';

const iconClass = mergeStyles({
    fontSize: 20,
    height: 20,
    width: 20,
});

export const ChartResource = ({ resource }) => {
    const [authentication] = useAtom(authenticationAtom);
    const [expanded, setExpanded] = useState(false);
    const [chartResource, setChartResource] = useState(null);

    // Apply color scheme

    useEffect(() => {
        const call = async () => {
            let newResource = null;

            if (resource.reference) {
                newResource = await userAPI.getResource(authentication.customer, resource.reference);
            } else {
                newResource = resource;
            }

            // Ensure chart options is always an object, never null or undefined
            if (!newResource.chart) {
                newResource.chart = {};
            }
            if (!newResource.chart.options) {
                newResource.chart.options = {};
            }

            // Title is already provided, this patches legacy
            delete newResource.chart.options.title;

            newResource.chart.options.colors = ['#649aaa', '#576071', '#33638F', '#BBBBBB'];

            setChartResource(newResource);
        }

        call();
    }, [resource]);

    return <div className="resource">
        <div className="displayFlex alignItemsCenter">
            <IconButton className="marginRightM" iconProps={{ iconName: expanded ? 'ChevronUp' : 'ChevronDown' }} onClick={() => setExpanded(!expanded)} />
            <FontIcon aria-label="Map" iconName="StackedColumnChart2Fill" className={iconClass} />
            <div className="marginLeftS flexGrow1 displayFlex title">{chartResource?.title}</div>
        </div>
        {expanded &&
            chartResource
            ?
            <div className='paddingM displayFlex justifyContentCenter'>
                <div>                   
                    {(() => {
                        try {
                            if (!chartResource?.chart?.options || !chartResource?.chart?.series || !chartResource?.chart?.type) {
                                return <div className="textM">No chart data available</div>;
                            }

                            return <Chart
                                options={chartResource.chart.options}
                                series={chartResource.chart.series}
                                type={chartResource.chart.type}
                                height={350}
                                width={600}
                            />;
                        } catch (error) {
                            console.error('Error rendering chart:', error);
                            return <div className="textM colorRed">Error rendering chart. Please try again later.</div>;
                        }
                    })()}
                </div>
            </div>
            :
            <></>
        }
    </div>;
}
